import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/signals/causality'
import { Error } from '../../actions/error/error'
import config from '../../../config'; // Adjust the path based on where the file is located
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    const { windows = 5, signal_count = 50, significance_level = 0.05, max_lag } = action.payload || {};
    
    let url = `${config.API_URL}/signal/causality?windows=${windows}&signal_count=${signal_count}&significance_level=${significance_level}`;
    
    if (max_lag !== undefined && max_lag !== null) {
      url += `&max_lag=${max_lag}`;
    }
    
    const response = yield call(
        axios.get,
        url,
        { headers: getLocalUser() }
      );
    yield put(fetchSuccess(response.data.data || response.data));
  } catch (error) {
    yield put(Error(error))
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
} 